import { render, staticRenderFns } from "./ModalInquiryDetail.vue?vue&type=template&id=56cf910c&scoped=true&"
import script from "./ModalInquiryDetail.vue?vue&type=script&lang=js&"
export * from "./ModalInquiryDetail.vue?vue&type=script&lang=js&"
import style0 from "./ModalInquiryDetail.vue?vue&type=style&index=0&id=56cf910c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cf910c",
  null
  
)

export default component.exports